/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './archive.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../../app/modules/employee/pages/archives/archive/archive.component';
import * as i6 from 'primeng/components/dom/domhandler';
import * as i7 from 'primeng/components/button/button';
import * as i8 from '../../../../../../../app/modules/employee/service/archive/archive.service';
import * as i9 from '@angular/router';
const styles_ArchiveComponent:any[] = [i0.styles];
export const RenderType_ArchiveComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ArchiveComponent,data:{}});
function View_ArchiveComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),14,'div',[['class',
      'col-md-12 col-sm-12']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),11,'ul',[['class','list-group']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n			'])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),8,
      'li',[['class','list-group-item']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n				'])),
      (_l()(),i1.ɵeld(6,0,(null as any),(null as any),2,'b',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(7,
          (null as any),['',''])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,
          i1.ChangeDetectorRef]),(_l()(),i1.ɵted(-1,(null as any),['\n				'])),(_l()(),
          i1.ɵeld(10,0,(null as any),(null as any),1,'span',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(11,
          (null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n			'])),(_l()(),
          i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵted(-1,(null as any),['\n	']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i1.ɵunv(_v,7,0,i1.ɵnov(_v,8).transform('id'));
        _ck(_v,7,0,currVal_0);
        const currVal_1:any = _co.infoArchive.id;
        _ck(_v,11,0,currVal_1);
      });
}
export function View_ArchiveComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ArchiveComponent_1)),i1.ɵdid(3,16384,
          (null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),12,
          'div',[['class','form-group row']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),
      (_l()(),i1.ɵeld(8,0,(null as any),(null as any),9,'div',[['class','col-md-12 col-sm-12']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),
      (_l()(),i1.ɵeld(12,0,(null as any),(null as any),4,'button',[['class','btn btn-danger btn-raised'],
          ['label',' '],['pButton','']],(null as any),[[(null as any),'click']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i5.ArchiveComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.cancelArchive()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵprd(512,(null as any),i6.DomHandler,i6.DomHandler,
          ([] as any[])),i1.ɵdid(14,4341760,(null as any),0,i7.Button,[i1.ElementRef,
          i6.DomHandler],{label:[0,'label']},(null as any)),(_l()(),i1.ɵted(15,(null as any),
          [' ',' '])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i5.ArchiveComponent = _v.component;
    const currVal_0:any = _co.infoArchive;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = ' ';
    _ck(_v,14,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = i1.ɵunv(_v,15,0,i1.ɵnov(_v,16).transform('close'));
    _ck(_v,15,0,currVal_2);
  });
}
export function View_ArchiveComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-archive',
      ([] as any[]),(null as any),(null as any),(null as any),View_ArchiveComponent_0,
      RenderType_ArchiveComponent)),i1.ɵdid(1,114688,(null as any),0,i5.ArchiveComponent,
      [i8.ArchiveService,i9.ActivatedRoute],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ArchiveComponentNgFactory:i1.ComponentFactory<i5.ArchiveComponent> = i1.ɵccf('app-archive',
    i5.ArchiveComponent,View_ArchiveComponent_Host_0,{infoArchive:'infoArchive'},{msg:'msg',
        close:'close'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/archives/archive/archive.component.ngfactory.ts